"use client";

import { useEffect } from "react";
import { ErrorBoundaryView } from "./ErrorBoundaryView";

export default function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <ErrorBoundaryView
      onReload={reset}
      onBack={() => {
        if (window.history.length > 1) {
          window.history.back();
          return;
        }
        window.location.assign("/");
      }}
    />
  );
}
